// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".formfort-app{width:100%}.formfort-cannot-load{padding:8px;margin:16px}.form-top-error,.formfort-cannot-load{border:1px solid red;background:#ffefef}.form-top-error{color:red;font-style:oblique;width:100%;font-size:16px;padding:10px 0 10px 0}.form-top-error p{padding:4px;text-align:center}", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
